import type {IResponseStat} from '../../../../types'
import {DialogTextCard} from '../DialogTextCard/DialogTextCard'
import styles from './DialogReplies.module.scss'

interface IDialogRepliesProps {
  replies: IResponseStat[]
  isUserModerator?: boolean
}

export const DialogReplies: React.FC<IDialogRepliesProps> = ({
  replies,
  isUserModerator = false,
}) => (
  <div className={styles.dialogReplies}>
    {replies.map(reply => (
      <DialogTextCard
        key={reply.id}
        data={reply}
        isReply={true}
        isUserModerator={isUserModerator}
      />
    ))}
  </div>
)
